
const closeSelect = {
  bind(el, binding, vnode) {
//这里el是有滚动条的父盒子
//获取盒子下所有下拉框
    let target = el.getElementsByClassName('el-select-dropdown')
//处理方法 让所有下拉框隐藏
    el.handler = () => {
        for (let item of target) {
            item.style.display = 'none'
        }
    }
//监听父子滚动
    el.addEventListener('scroll', el.handler)
  }
}

export default closeSelect



// WEBPACK FOOTER //
// ./src/digitalHuman/directives/closeSelect.js